// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"97edb9b5","455":"a3fccc75","977":"c99373ef"}[chunkId] + ".chunk.js";
};